import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL || '';
const ragAdminKey = process.env.REACT_APP_RAG_ADMIN_KEY || '';

export async function fetchChatNumbers(id: string, orgId: string) {
	const body = {
		userId: id,
		org_id: orgId,
	};

	try {
		const response = await axios.post(`${baseUrl}/list_user_ids`, body);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function fetchChats(
	phoneNumber: string,
	userId?: string,
	orgId?: string,
) {
	const body = {
		userId: phoneNumber,
		// userId: userId,
		org_id: orgId,
	};
	try {
		const response = await axios.post(`${baseUrl}/get_conversation`, body);
		return response.data.conversation;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function fetchAgentRequestsList() {
	const body = {
		name: 'test',
	};

	try {
		const response = await axios.post(`${baseUrl}/Userinputs`, body);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function fetchChatHistoryList() {
	const body = {
		name: 'test',
	};

	try {
		const response = await axios.post(`${baseUrl}/Newchat`, body);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function onEnableAgentMode(
	phoneNumber: string,
	status: string,
	orgId: string,
) {
	const body = {
		userId: phoneNumber,
		mode: status,
		org_id: orgId,
	};

	try {
		const response = await axios.post(
			`${baseUrl}/consultant_mode_switch`,
			body,
		);
		if (response.status === 200) {
			return { error: false, message: 'Success' };
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function updateChatLanguage(
	phoneNumber: string,
	language: string,
	orgId: string,
) {
	const body = {
		userId: phoneNumber,
		lang: language,
		org_id: orgId,
	};

	try {
		const response = await axios.post(
			`${baseUrl}/set_conversation_language`,
			body,
		);
		if (response.status === 200) {
			return { error: false, message: 'Success' };
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function sendMessage(
	phoneNumber: string,
	message: string,
	orgId: string,
	replyToWamid?: string,
) {
	const body = {
		userId: phoneNumber,
		response_text: message,
		org_id: orgId,
		...(replyToWamid ? { wamid: replyToWamid } : {}),
	};

	try {
		const response = await axios.post(
			`${baseUrl}/consultant_send_message`,
			body,
		);

		if (response.status === 200) {
			return { error: false, message: 'Success' };
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function fetchConsultantSuggestedResponse(
	phoneNumber: string,
	orgId: string,
	wamid?: string,
) {
	const body = {
		userId: phoneNumber,
		org_id: orgId,
		wamid: wamid,
	};

	try {
		const response = await axios.post(`${baseUrl}/get_drafts`, body);

		if (response.status === 200) {
			return { ...response.data, error: false };
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function uploadPdf(
	file: File,
	version: string,
	botPhoneNumber: string,
	token: string,
	userId: string,
	orgId: string,
) {
	const form = new FormData();

	form.append('file', file, file.name);
	form.append('type', 'png');
	form.append('messaging_product', 'whatsapp');
	form.append('userId', userId);
	form.append('org_id', orgId);

	try {
		const response = await axios.post(
			`https://graph.facebook.com/${version}/${botPhoneNumber}/media`,
			form,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);

		if (response.status === 200) {
			return { data: response.data, error: false, message: 'Success' };
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function sendUploadIdAndMessage(
	uploadedId: string,
	phoneNumber: string,
	caption: string,
	fileName: string,
	orgId: string,
	replyToWamid?: string,
) {
	const body = {
		userId: phoneNumber,
		caption: caption,
		media_id: uploadedId,
		file_name: fileName,
		org_id: orgId,
		...(replyToWamid ? { wamid: replyToWamid } : {}),
	};

	try {
		const response = await axios.post(
			`${baseUrl}/consultant_send_message`,
			body,
		);

		if (response.status === 200) {
			return { error: false, message: 'Success' };
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function onFetchUploadInfo() {
	try {
		const response = await axios.get(`${baseUrl}/token`);

		if (response.status === 200) {
			return response.data;
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function downloadMediaFile(
	mediaId: string,
	userId: string,
	orgId: string,
) {
	const body = {
		media_id: mediaId,
		userId: userId,
		org_id: orgId,
	};

	try {
		const metadataResponse = await axios.post(
			`${baseUrl}/binary_data`,
			body,
			{ responseType: 'blob' },
		);

		if (metadataResponse.status === 200) {
			return {
				data: metadataResponse.data,
				error: false,
				message: 'Success',
			};
		} else {
			return {
				error: true,
				message: `Failed to fetch media file: ${metadataResponse.status}`,
			};
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function sendStudioChatMessage(
	id: string,
	message: string,
	orgId: string,
) {
	const body = {
		userId: id,
		question: message,
		org_id: orgId,
	};

	try {
		const response = await axios.post(`${baseUrl}/common_chat`, body);

		if (response.status === 200) {
			return { ...response.data, error: false };
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.response?.data };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function uploadKnowledgePdf(data: FormData) {
	try {
		const response = await axios.post(
			`${baseUrl}/upload_senzagro_pdf/`,
			data,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
					'X-Admin-Key': ragAdminKey,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return {
				error: true,
				status: error.response?.status,
				message: error.response?.data?.detail ?? error.message,
			};
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function uploadRagImages(data: FormData) {
	try {
		const response = await axios.post(`${baseUrl}/admin/rag/images`, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
				'X-Admin-Key': ragAdminKey,
			},
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return {
				error: true,
				status: error.response?.status,
				message: error.response?.data?.detail ?? error.message,
			};
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function onFetchKnowledgeUploads(userId: string, orgId: string) {
	const body = {
		userId: userId,
		org_id: orgId,
	};

	try {
		const response = await axios.post(`${baseUrl}/list_pdf`, body);

		if (response.status === 200) {
			return response.data;
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function onRemoveKnowledgeUpload(
	fileName: string,
	userId: string,
	orgId: string,
) {
	try {
		const data = {
			name: fileName,
			userId: userId,
			org_id: orgId,
		};

		const response = await axios.post(`${baseUrl}/delete_pdf`, data, {
			headers: {
				'X-Admin-Key': ragAdminKey,
			},
		});

		if (response.status === 200) {
			return response.data;
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.response?.data };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function uploadWebUrl(url: string, userId: string, orgId: string) {
	const data = {
		site_map: url,
		userId: userId,
		org_id: orgId,
	};

	try {
		const response = await axios.post(`${baseUrl}/select_urls`, data);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.response?.data };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function uploadSelectedWebUrl(
	mainUrl: string,
	urls: string[],
	userId: string,
	orgId: string,
) {
	const data = {
		site_map: mainUrl,
		site_map_urls: urls,
		userId: userId,
		org_id: orgId,
	};

	try {
		const response = await axios.post(
			`${baseUrl}/upload_tourism_website`,
			data,
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.response?.data };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function onFetchKnowledgeUploadUrls(
	userId: string,
	orgId: string,
) {
	const body = {
		userId: userId,
		org_id: orgId,
	};
	try {
		const response = await axios.post(
			`${baseUrl}/list_tourism_website`,
			body,
		);

		if (response.status === 200) {
			return response.data;
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function onRemoveKnowledgeUploadUrl(
	url: string,
	userId: string,
	orgId: string,
) {
	try {
		const data = {
			site_url: url,
			userId: userId,
			org_id: orgId,
		};

		const response = await axios.post(`${baseUrl}/delete_website`, data);

		if (response.status === 200) {
			return response.data;
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.response?.data };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function fetchRagImageVocabulary() {
	try {
		const response = await axios.get(
			`${baseUrl}/admin/rag/images/vocabulary`,
			{
				headers: {
					'X-Admin-Key': ragAdminKey,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return {
				error: true,
				status: error.response?.status,
				message: error.response?.data?.detail ?? error.message,
			};
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function onRemoveRagImage(
	name: string,
	userId: string,
	orgId: string,
) {
	try {
		const data = {
			name: name,
			userId: userId,
			org_id: orgId,
		};

		const response = await axios.delete(`${baseUrl}/admin/rag/images`, {
			data,
			headers: {
				'X-Admin-Key': ragAdminKey,
			},
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return {
				error: true,
				status: error.response?.status,
				message: error.response?.data?.detail ?? error.message,
			};
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function fetchTestChats(userId: string, orgId: string) {
	const body = {
		userId: userId,
		org_id: orgId,
	};

	try {
		const response = await axios.post(
			`${baseUrl}/get_test_conversation`,
			body,
		);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function getUnreadMsgStatus(userId: string, orgId: string) {
	const body = {
		userId: userId,
		org_id: orgId,
	};

	try {
		const response = await axios.post(`${baseUrl}/`, body);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function updateUnreadMsgStatus(
	userId: string,
	orgId: string,
	type: string,
) {
	const changingType = type === 'Studio' ? {} : {};

	const body = {
		userId: userId,
		org_id: orgId,
		...changingType,
	};

	try {
		const response = await axios.post(`${baseUrl}/`, body);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function onResetChatMsgCount(phoneNumber: string, orgId: string) {
	const body = {
		user_id: phoneNumber,
		org_id: orgId,
	};

	try {
		const response = await axios.post(
			`${baseUrl}/mark_as_read_testchat`,
			body,
		);

		if (response.status === 200) {
			return response.data;
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}

export async function markMessageAsUnread(
	phoneNumber: string,
	wamid: string,
	orgId: string,
) {
	const body = {
		user_id: phoneNumber,
		wamid: wamid,
		org_id: orgId,
		read: false,
	};

	try {
		const response = await axios.post(`${baseUrl}/set_read_status`, body);

		if (response.status === 200) {
			return { error: false, message: 'Success' };
		} else {
			throw response;
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			return { error: true, message: error.message };
		} else {
			console.error('Something went wrong', error);
			return { error: true, message: error };
		}
	}
}
